module.exports = __webpack_public_path__ + "img/take_course.6fae10ca.png";